function _s(o, i, p, l) { void 0 === i && (i = 400), void 0 === l && (l = !1), o.style.overflow = "hidden", l && (o.style.display = "block"); var n, t = window.getComputedStyle(o), s = parseFloat(t.getPropertyValue("height")), a = parseFloat(t.getPropertyValue("padding-top")), r = parseFloat(t.getPropertyValue("padding-bottom")), y = parseFloat(t.getPropertyValue("margin-top")), d = parseFloat(t.getPropertyValue("margin-bottom")), g = s / i, m = a / i, h = r / i, u = y / i, x = d / i; window.requestAnimationFrame(function t(e) { void 0 === n && (n = e); e -= n; l ? (o.style.height = g * e + "px", o.style.paddingTop = m * e + "px", o.style.paddingBottom = h * e + "px", o.style.marginTop = u * e + "px", o.style.marginBottom = x * e + "px") : (o.style.height = s - g * e + "px", o.style.paddingTop = a - m * e + "px", o.style.paddingBottom = r - h * e + "px", o.style.marginTop = y - u * e + "px", o.style.marginBottom = d - x * e + "px"), i <= e ? (o.style.height = "", o.style.paddingTop = "", o.style.paddingBottom = "", o.style.marginTop = "", o.style.marginBottom = "", o.style.overflow = "", l || (o.style.display = "none"), "function" == typeof p && p()) : window.requestAnimationFrame(t) }) } HTMLElement.prototype.slideToggle = function (t, e) { 0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e) }, HTMLElement.prototype.slideUp = function (t, e) { _s(this, t, e) }, HTMLElement.prototype.slideDown = function (t, e) { _s(this, t, e, !0) };

let PACK_SELECTION = {};

let packItems = []

let total_quantity_global = false;

const passedIds = new Set();
for (let item of bundleData.bundle_products) {
    const variantId = item.variants[0].id;

    if (!passedIds.has(variantId)) {
        const newItem = {
            id: variantId,
            productId: item.id,
            handle: item.handle,
             weight:  item.variants[0].title.split('g')[0] == "Default Title" ? 200 : item.variants[0].title.split('g')[0],
            title: item.title,
            quantity: 0,
            price: item.price
        };
        packItems.push(newItem);
        passedIds.add(variantId);
    }
}

class ProductTemplate extends HTMLElement {
    constructor() {
        super();


        this.initSwiper();

        this.querySelector('.product-form__submit').addEventListener('click', this.submitForm.bind(this));
        this.initEvents();

        this.querySelectorAll('.product-form__products--navigation__item').forEach((elem) => {
            elem.addEventListener('click', this.updateCollectionContent.bind(this))
        })

        document.querySelector('.product-form__products--navigation__item:not(.hidden-force)').click();

        this.calculateShipping();


        document.querySelectorAll('[data-open-modal-product]').forEach((elem) => {
            elem.addEventListener('click', this.toggleFaqItemItems.bind(this));
        });


        this.all_packs_container = document.querySelectorAll("pack-item");
        this.last_number_selection = 0;
        this.first_load = true;
        this.content_updated = false;

        let parent = document.querySelector('.product-form__submit').parentElement;

        while (parent) {
            const hasOverflow = getComputedStyle(parent).overflow;
            if (hasOverflow !== 'visible') {
                console.log(hasOverflow, parent);
            }
            parent = parent.parentElement;
        }

    }


    initSwiper() {
        const swiper = new Swiper('.product-media__items-medias .swiper', {
            slidesPerView: 'auto',
            navigation: {
                nextEl: '.product-media__items-medias .swiper-button-next',
                prevEl: '.product-media__items-medias .swiper-button-prev',
            },

        });
        const swiper2 = new Swiper('.product-media__items-medias .swiper_second', {
            slidesPerView: 'auto',
            navigation: {
                nextEl: '.product-media__items-medias .swiper_second .swiper-button-next',
                prevEl: '.product-media__items-medias .swiper_second .swiper-button-prev',
            },

        });
    }


    updateCollectionContent(e) {
        let current = e.currentTarget;
        let collection_id = current.dataset.handle;

        document.querySelectorAll('.product-form__products--navigation__item').forEach((elem) => {
            elem.classList.remove('actif');
        })

        current.classList.add('actif');

        document.querySelectorAll('.product-form__product-item[data-handle]').forEach((elem) => {
            elem.classList.add('hidden');
        })

        // if product-form__product-item data-handle contain the collection_id we remove the hidden class

        document.querySelectorAll(`.product-form__product-item[data-handle]`).forEach((elem) => {
            let elem_collection_id = elem.dataset.handle.split(' , ');
            console.log(elem_collection_id);

            if (elem_collection_id.includes(collection_id)) {
                elem.classList.remove('hidden');
            }
        }
        )


    }

    calculateShipping() {
        if (this.querySelector('.product-form__icon')) {
            // calculate shipping date from today + shipping delay exclude weekends
            let shipping_date = new Date(new Date().getTime());
            let shipping_delay = parseInt(this.getAttribute('data-shipping-delay'));


            for (var i = 0; i < shipping_delay; i++) {
                shipping_date.setDate(shipping_date.getDate() + 1);
                if (shipping_date.getDay() == 6) {
                    shipping_date.setDate(shipping_date.getDate() + 2);
                }
                if (shipping_date.getDay() == 0) {
                    shipping_date.setDate(shipping_date.getDate() + 1);
                }
            }

            // get french date format day month year
            let shipping_date_format = shipping_date.toLocaleDateString('fr-FR', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });

            for (let i = 0; i < document.querySelectorAll('.product-form__icon').length; i++) {
                let html = document.querySelectorAll('.product-form__icon')[i].innerHTML;
                if (html.indexOf('[date]') > -1) {
                    document.querySelectorAll('.product-form__icon')[i].innerHTML = html.replace('[date]', shipping_date_format);
                }
            }
        }
    }

    submitForm() {

        if (document.querySelector('.variant-item__pack.active')) {

            let quantity = 1;
            let variant_id = parseInt(document.querySelector('.variant-item__pack.active').dataset.productVariantId);

            const data = {
                items: [
                    {
                        id: variant_id,
                        quantity: quantity
                    }
                ]
            }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then((response) => {
                console.log(response);
                this.submitBundle();
            }).catch((error) => {
                console.error('Error:', error);
            }
            )

        } else {
            document.querySelector(".product-form__submit").classList.add("loading");

            let selections_items = [];

            let packs__quantity = 0;

            for (const item of PACK_SELECTION.pack_items) {
                packs__quantity += item.quantity;
            }

            if (packs__quantity != 0) {
                // add to cart the pack selection

                for (const item of PACK_SELECTION.pack_items) {
                    if (item.quantity > 0) {
                        selections_items.push({
                            id: item.id,
                            quantity: item.quantity
                        })
                    }
                }

                const data = {
                    items: selections_items
                }

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then((response) => {
                    console.log(response);
                    this.submitBundle();
                }).catch((error) => {
                    console.error('Error:', error);
                }
                )
            }
        }
    }

    submitBundle() {
        document.querySelector(".product-form__submit").classList.remove("loading");
    }

    initEvents() {
        this.querySelectorAll(".faq-item-title").forEach((button) => {
            button.addEventListener("click", this.toggleFaqItem.bind(this));
        });

        document
            .querySelectorAll(".selection-packs-upgrade__decline")
            .forEach((button) => {
                button.addEventListener("click", () => {
                    document
                        .querySelectorAll(".selection-packs-upgrade")
                        .forEach((item) => {
                            item.classList.remove("open");
                        });
                });
            });
    }


    toggleFaqItemItems(e) {
        e.currentTarget.classList.toggle("faq-open");

        const item = e.currentTarget.closest('.product-form__product-item').querySelector(".product-item__details");

        item.slideToggle("250");
    }

    toggleFaqItem(e) {
        e.currentTarget
            .querySelector(".faq-close")
            .classList.toggle("faq-display-none");

        const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
        console.log(item);

        item.slideToggle("250");
    }
}

customElements.define('product-template', ProductTemplate);

window.addEventListener('load', function () {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
});
window.addEventListener('resize', function () {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
});

class VariantItem extends HTMLElement {
    constructor() {
        super();

        this.updatePackContent()
        this.addEventListener('click', this.toggleVariant.bind(this));


        let handle_pack = document.querySelector('[data-change-variant]').dataset.changeVariant;
        //  if url contain ?pack-degustation or ?compo we open the modal
        if (window.location.href.indexOf(`?${handle_pack}`) > -1) {
            document.querySelector('.variant-item__pack').click();
        }
    }

    toggleVariant() {
        document.querySelectorAll('variant-item').forEach((item) => {
            item.classList.remove('active');
        });
        this.classList.add('active');
        this.updatePackContent();
    }


    updatePackContent() {

        if (this.classList.contains("variant-item__compo")) {

            document.querySelectorAll('.product-media__item__custom').forEach((elem) => {
                elem.classList.remove('active');
            });
            document.querySelectorAll('.product-media__item:not(.product-media__item__custom, .product-media__item--image)').forEach((elem) => {
                elem.classList.remove('hidden');
            });
            document.querySelector('.product-form__products__compo').classList.remove('hidden');
            document.querySelector('.product-form__variant__compareatprice').classList.remove('hidden');
            document.querySelector('.product-form__variant__compareatprice_pack ').classList.add('hidden');
            document.querySelector('.product-form__pack-price').classList.add('hidden');
            document.querySelector('.product-form__products__pack').classList.add('hidden');
            document.querySelector('.product-form__variant__price.perso').classList.remove('hidden');
            document.querySelector('.product-form__variant__price.pack').classList.add('hidden');

            document.querySelector('.main-product-media__container--custom_second')?.classList.add('hidden');
            document.querySelector('.main-product-media__container--custom').classList.remove('hidden-force');

            document.querySelector('.product-media__items-medias_second')?.classList.add('hidden');
            document.querySelector('.product-media__items-medias_first')?.classList.remove('hidden');

            // We update the pack selection object
            PACK_SELECTION = {
                pack_items: PACK_SELECTION.pack_items ? PACK_SELECTION.pack_items : packItems,
            };

            if (PACK_SELECTION.pack_items) {
                let total = 0;
                for (const item of PACK_SELECTION.pack_items) {
                    total += item.quantity;
                }

                if (total == 0) {
                    document.querySelector('.product-form__submit').classList.add('disabled');
                    document.querySelector('.product-form__variant-price').style.display = 'none';

                }

                if (total != 0) {
                    document.querySelector('.product-form__content-items').classList.remove('hidden');
                    document.querySelector('.product-form__submit').classList.remove('disabled');
                    document.querySelector('.product-form__variant-price').style.display = 'block';
                }

                document.querySelectorAll('[data-action="increment"]').forEach((elem) => {
                    elem.setAttribute("disabled", "false");
                });
            }

            // this.updatePriceCta();
            this.updatePageContent();

        }
        else {


            document.querySelector('.product-form__products__compo').classList.add('hidden');
            document.querySelector('.product-form__submit').classList.remove('disabled');
            document.querySelector('.product-form__pack-price').classList.remove('hidden');
            document.querySelector('.product-form__variant__compareatprice').classList.add('hidden');
            document.querySelector('.product-form__variant__compareatprice_pack ').classList.remove('hidden');
            document.querySelector('.product-form__content-items').classList.add('hidden');
            document.querySelector('.product-form__variant-price').style.display = 'none';
            document.querySelector('.product-form__products__pack').classList.remove('hidden');
            document.querySelector('.product-form__variant__price.perso').classList.add('hidden');
            document.querySelector('.product-form__variant__price.pack').classList.remove('hidden');

            document.querySelector('.product-media__items-medias_second')?.classList.remove('hidden');
            document.querySelector('.product-media__items-medias_first')?.classList.add('hidden');

            document.querySelectorAll('.product-media__item__custom').forEach((elem) => {
                elem.classList.add('active');
            });

            document.querySelectorAll('.product-media__item:not(.product-media__item__custom, .product-media__item--image)').forEach((elem) => {
                elem.classList.add('hidden');
            });

            document.querySelector('.main-product-media__container--custom_second')?.classList.remove('hidden');
            document.querySelector('.main-product-media__container--custom').classList.add('hidden-force');

        }
    }

    updatePageContent() {

        //  change source image to show the pack selection

        document.querySelectorAll('.product-media__item--image').forEach((elem) => {
            elem.parentNode.classList.add('hidden');
        })

    }

}

customElements.define('variant-item', VariantItem);

class QuantityInput extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[name="quantity"]');
        this.addEventListener("click", this.changeQuantity.bind(this));
        this.addEventListener("updateContent", this.changeQuantity.bind(this));

        this.querySelector('.product--quantity__init').addEventListener('click', function () {
            this.querySelector('[data-action="increment"]').click();
            this.querySelector('.product--quantity__init').classList.add('hidden');
        }.bind(this));


        this.updatecoffeesCounter();

    }

    changeQuantity(event) {

        document.querySelector('.product-form__custom_label').classList.remove('hidden')

        let target = event.target;
        let total = 0;

        // Get the total quantity of coffees in the pack
        for (const item of PACK_SELECTION.pack_items) {
            total += item.quantity;
        }

        // console.log(total, PACK_SELECTION.coffee_times);

        const value = parseInt(this.input.value);

        if (target.classList.contains("quantity-input__btn")) {
            if (target.dataset.action === "increment") {

                target
                    .closest("quantity-input")
                    .querySelector('[data-action="decrement"]')
                    .removeAttribute("disabled");
                // We update the input value with the new quantity
                this.input.value = parseInt(value) + 1;
                if (this.input.value == this.input.max) {
                    this.parentNode.classList.add('out-of-stock-dinamique');
                }
            } else if (target.dataset.action === "decrement") {
                this.parentNode.classList.remove('out-of-stock-dinamique');
                document.querySelectorAll('[data-action="increment"]').forEach((elem) => {
                    elem.setAttribute("disabled", "false");
                });
                if (value > 0) {
                    this.input.value = parseInt(value) - 1;
                    // We update the input value with the new quantity
                    if (this.input.value == 0) {
                        target.setAttribute("disabled", "disabled");
                    }

                } else {
                }
            }
        }

        let total_coffees = 0;

        if (this.input.value == 0) {
            this.querySelector('.product--quantity__init').classList.remove('hidden');
        }

        let quantity_inputs = document.querySelectorAll(
            '.product-form__product-item quantity-input [name="quantity"][data-handle]'
        );

        for (const input of quantity_inputs) {
            total_coffees += parseInt(input.value);
        }

        let progress_1 = document.querySelector('.product-form__progress--bar-item-1[data-reduction-step]');
        let progress_2 = document.querySelector('.product-form__progress--bar-item-2[data-reduction-step]');
        let progress_3 = document.querySelector('.product-form__progress--bar-item-3[data-reduction-step]');

        let current_reduction = 0;

        let quantity_1 = progress_1.dataset.reductionStep
        let quantity_2 = progress_2.dataset.reductionStep
        let quantity_3 = progress_3.dataset.reductionStep

        let current_reste = 0;
        let current_reduction_content = document.querySelector('.product-form__progress--bar-item-1 .progress__reduction');

        if (total_coffees <= parseInt(progress_1.dataset.reductionStep)) {
            let multiply = 100 / Number(progress_1.dataset.reductionStep);
            document.querySelector('.product-form__progress--bar-item-1[data-reduction-step] .progress__fill .fill__content').style.width = `${multiply * total_coffees}%`;
            document.querySelector('.product-form__progress--bar-item-2[data-reduction-step] .progress__fill .fill__content').style.width = `0%`;
            if (total_coffees == Number(progress_1.dataset.reductionStep)) {
                progress_1.classList.add('active');
                current_reduction = Number(progress_1.dataset.reduction);
                current_reduction_content = Number(progress_2.dataset.reduction)
                current_reste = Number(progress_2.dataset.reductionStep) - total_coffees;
            } else {
                document.querySelector('.product-form__progress--bar-item-1[data-reduction-step] ').classList.remove('active');
                current_reduction_content = document.querySelector('.product-form__progress--bar-item-1 .progress__reduction');
                current_reduction = 0;
                current_reduction_content = Number(progress_1.dataset.reduction)
                current_reste = Number(progress_1.dataset.reductionStep) - total_coffees;
            }
        }


        if (total_coffees > parseInt(progress_1.dataset.reductionStep) && total_coffees <= parseInt(progress_2.dataset.reductionStep)) {
            let multiply = 100 / (Number(progress_2.dataset.reductionStep) - Number(progress_1.dataset.reductionStep));
            document.querySelector('.product-form__progress--bar-item-2[data-reduction-step] .progress__fill .fill__content').style.width = `${Number(multiply.toFixed(2)) * (total_coffees - (Number(progress_2.dataset.reductionStep) - Number(progress_1.dataset.reductionStep)))}%`;
            document.querySelector('.product-form__progress--bar-item-3[data-reduction-step] .progress__fill .fill__content').style.width = `0%`;
            current_reduction = Number(progress_1.dataset.reduction)
            if (total_coffees == Number(progress_2.dataset.reductionStep)) {
                progress_2.classList.add('active');
                current_reduction = Number(progress_2.dataset.reduction)
                document.querySelector('.product-form__progress--bar-item-2[data-reduction-step] .progress__fill .fill__content').style.width = `100%`;
                current_reduction_content = Number(progress_2.dataset.reduction)
                current_reste = Number(progress_3.dataset.reductionStep) - total_coffees;
            } else {
                progress_2.classList.remove('active');
                current_reduction_content = document.querySelector('.product-form__progress--bar-item-2 .progress__reduction');
                current_reste = Number(progress_2.dataset.reductionStep) - total_coffees;
                current_reduction_content = Number(progress_2.dataset.reduction)
            }
        }

        if (total_coffees <= Number(progress_3.dataset.reductionStep) && total_coffees >= Number(progress_1.dataset.reductionStep)) {
            current_reduction = Number(progress_1.dataset.reduction);
        }

        if (total_coffees >= parseInt(progress_2.dataset.reductionStep) && total_coffees <= parseInt(progress_3.dataset.reductionStep)) {
            let multiply = 100 / (Number(progress_3.dataset.reductionStep) - Number(progress_2.dataset.reductionStep));
            document.querySelector('.product-form__progress--bar-item-3[data-reduction-step] .progress__fill .fill__content').style.width = `${Number(multiply.toFixed(2)) * (total_coffees - progress_2.dataset.reductionStep)}%`;
            current_reduction = Number(progress_2.dataset.reduction)
            if (total_coffees >= Number(progress_3.dataset.reductionStep)) {
                progress_3.classList.add('active');
                current_reduction = Number(progress_3.dataset.reduction);
                document.querySelector('.product-form__custom_label-text').classList.add('hidden');
                document.querySelector('.product-form__custom_label-complete').classList.remove('hidden');
                document.querySelector('.product-form__custom_label-complete .progress__reduction span').textContent = Number(progress_3.dataset.reduction);
            } else {
                progress_3.classList.remove('active');
                document.querySelector('.product-form__custom_label-text').classList.remove('hidden');
                current_reste = Number(progress_3.dataset.reductionStep) - total_coffees;
                current_reduction_content = Number(progress_3.dataset.reduction);
                document.querySelector('.product-form__custom_label-complete').classList.add('hidden');
            }
        }

        if (total_coffees >= Number(progress_3.dataset.reductionStep)) {
            current_reduction = Number(progress_3.dataset.reduction);
        }

        let current_reduction_details = current_reduction / 100;
        if (current_reduction == 0) {
            current_reduction_details = 1
        }

        console.log(current_reduction_details);

        if (current_reduction == 0) {
            document.querySelectorAll('[data-current-price-item-collection]').forEach((elem) => {
                let currentPrice = elem.dataset.currentPriceItemCollection;
                elem.querySelector('[data-current-compare-reduction]').textContent = '';
                elem.querySelector('[data-current-price-reduction]').textContent = ((currentPrice / 100) * current_reduction_details).toFixed(2) + '€';
            });
        } else {
            document.querySelectorAll('[data-current-price-item-collection]').forEach((elem) => {
                let currentPrice = elem.dataset.currentPriceItemCollection;
                elem.querySelector('[data-current-compare-reduction]').textContent = (currentPrice / 100).toFixed(2) + '€';
                elem.querySelector('[data-current-price-reduction]').textContent = ((currentPrice / 100) - ((currentPrice / 100) * current_reduction_details)).toFixed(2) + '€';
            });
        }



        document.querySelector('[data-current-rest]').textContent = current_reste;
        document.querySelector('[data-current-reduction] span').textContent = current_reduction_content;

        if (total_coffees === 0) {
            document.querySelector('.product-form__content-items').classList.add('hidden');
            document.querySelector('.product-form__variant-price').style.display = 'none';
        }
        else {
            document.querySelector('.product-form__variant-price').style.display = 'block';
        }
        this.updateSelectionContent();
        this.updatecoffeesCounter();
        let total_weight = 0;
        let number_cofee = 0;
       let coffe_by_paquet = document.querySelector('.product-list__pack-content-perso[data-coffee-times]').dataset.coffeeTimes;
        if (document.querySelector('[data-current-machine="dolce-gusto"]')) {
            coffe_by_paquet = 8.5;
        } else {
            coffe_by_paquet = 5;
        }
      
        for (const item of PACK_SELECTION.pack_items) {
            if (item.quantity != 0) {
                total_weight += Math.floor(item.weight * 1) * item.quantity;
                number_cofee += Math.floor(item.weight / coffe_by_paquet) * item.quantity;
            }
        }
         console.log(total_weight);
      
        console.log(total_weight / coffe_by_paquet);
        let total_coffees_number_coffee = 0;
        for (const input of document.querySelectorAll('.product-form__product-item quantity-input:not(.quantity-input-boite) [name="quantity"][data-handle]')) {
            total_coffees_number_coffee += parseInt(input.value);
        }
      
        document.querySelector('[data-nb-paquet]').textContent = number_cofee;

        document.querySelector('.selection__global [data-nb-pack]').textContent = total_coffees;
        document.querySelector('.detail__paquet [data-max-sachet] [data-quantity]').textContent = total_coffees_number_coffee;
        if (document.querySelector('.detail__paquet [data-max-boites] [data-quantity]')) {
          document.querySelector('.detail__paquet [data-max-boites] [data-quantity]').textContent = total_coffees;
        }        
       
        let total_price = 0

        console.log(total_price / 100);
        for (const item of PACK_SELECTION.pack_items) {
            if (item.quantity != 0) {
                total_price += item.price * item.quantity
            }
        }

        //  if current_reduction != 0 calcul price 
        document.querySelector('[data-compare-at-price]').classList.add('hidden')

        if (current_reduction != 0) {

            document.querySelector('.product-form__variant__compareatprice').classList.remove('hidden');
            document.querySelector('.product-form__variant__compareatprice').textContent = (total_price / 100).toFixed(2) + '€';
            document.querySelector('[data-price-coffee]').parentNode.parentNode.classList.remove('hidden')
            let total_price_compare = (total_price) * (current_reduction / 100)
            document.querySelector('[data-compare-at-price]').textContent = (total_price / 100).toFixed(2) + '€';
            document.querySelector('[data-compare-at-price]').classList.remove('hidden')
            document.querySelector('[data-price]').textContent = ((total_price - total_price_compare) / 100).toFixed(2) + '€';
            document.querySelector('[data-price-coffee]').textContent = (((total_price - total_price_compare)).toFixed(2) / number_cofee / 100).toFixed(2) + '€';
            document.querySelector('.product-form__submit [data-price]').textContent = ((total_price - total_price_compare) / 100).toFixed(2) + '€';
        } else {
            document.querySelector('.product-form__variant__compareatprice').classList.add('hidden');
            document.querySelector('[data-price-coffee]').classList.remove('hidden')
            document.querySelector('[data-price]').textContent = ((total_price) / 100).toFixed(2) + '€';
            document.querySelector('[data-price-coffee]').textContent = (((total_price)).toFixed(2) / number_cofee / 100).toFixed(2) + '€'
            document.querySelector('.product-form__submit [data-price]').textContent = ((total_price) / 100).toFixed(2) + '€';
        }

        if (total_coffees == 0) {
            document.querySelector('[data-price-coffee]').textContent = 0 + '€';
            document.querySelector('.product-form__submit').classList.add('disabled');
        }
        else {
            document.querySelector('.product-form__submit').classList.remove('disabled');
        }
    }



    updatecoffeesCounter() { }

    updateSelectionContent() {

        console.log('change quantity');
        const quantity_inputs = document.querySelectorAll(
            ".product-form__product-item quantity-input"
        );
        for (const input of quantity_inputs) {
            for (let item of PACK_SELECTION.pack_items) {
                // Update the quantity of each smoothie in the pack selection object
                if (item.handle === input.querySelector("input").dataset.handle) {
                    item.quantity = parseInt(input.querySelector("input").value);
                    console.log(item);
                }
            }
        }
        let index = 0;
        let content_pack = document.querySelector("[data-pack-content]").textContent;
        content_pack = '';
        let content_updated = '';

        console.log(PACK_SELECTION.pack_items);

        for (const item of PACK_SELECTION.pack_items) {
            if (item.quantity > 0) {
                console.log(item.title);
                document.querySelector('.product-form__content-items').classList.remove('hidden');
                if (index == 0) {
                    content_updated += (`${item.title} (${item.quantity})`);
                }
                else {
                    content_updated += (`, ${item.title} (${item.quantity})`);
                }
                index++;
            }
        }

        document.querySelector("[data-pack-content]").textContent = content_updated;
    }
}

if (customElements.get("quantity-input") === undefined) {
    customElements.define("quantity-input", QuantityInput);
}


const disabledLinks = (urls, attr, setAttr) => {
    [...urls].forEach(url => {
        url.setAttribute(attr, setAttr)
    })
}

const blockedLinks = (down) => {
    const allLinks = document.querySelectorAll('.url-card');
    down
        ? disabledLinks(allLinks, 'disabled', 'disabled')
        : disabledLinks(allLinks, 'disabled', '')
}


